import React from "react";
import { Box, Card, CardContent, IconButton, Stack, Typography } from "@mui/material";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export const CrisisReferralCard = ({ onDismiss }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        mx: "auto",
        my: 1.5,
        width: "100%",
        maxWidth: 720,
        backgroundColor: "#FFF7ED",
        borderRadius: "14px",
        borderColor: "rgba(249, 115, 22, 0.4)",
        boxShadow: "0 2px 8px rgba(234, 88, 12, 0.08)",
      }}
    >
      <CardContent sx={{ p: { xs: 2, sm: 2.25 }, "&:last-child": { pb: { xs: 2, sm: 2.25 } } }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <FavoriteRoundedIcon sx={{ color: "#EA580C", fontSize: 20 }} />
            <Typography
              sx={{
                fontWeight: 750,
                fontSize: 14,
                color: "#9A3412",
                fontFamily: "'Work Sans', 'Plus Jakarta Sans', sans-serif",
              }}
            >
              Support Resources
            </Typography>
          </Stack>
          {onDismiss && (
            <IconButton
              size="small"
              onClick={onDismiss}
              aria-label="Dismiss crisis resources"
              sx={{ color: "#9A3412", p: 0.5, "&:hover": { backgroundColor: "rgba(154, 52, 18, 0.08)" } }}
            >
              <CloseRoundedIcon sx={{ fontSize: 18 }} />
            </IconButton>
          )}
        </Stack>

        <Typography sx={{ fontSize: 13, color: "#7C2D12", lineHeight: 1.4, mb: 1.25 }}>
          If you or someone you know needs immediate help, confidential support is available 24/7:
        </Typography>

        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "10px",
            p: 1.5,
            border: "1px solid rgba(249, 115, 22, 0.2)",
          }}
        >
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 700,
              color: "#9A3412",
              mb: 0.5,
              display: "flex",
              alignItems: "center",
              gap: 0.75,
            }}
          >
            <span>📞</span>
            <a
              href="tel:988"
              style={{ color: "#9A3412", textDecoration: "underline", fontWeight: 700 }}
            >
              9-8-8 Suicide &amp; Crisis Helpline
            </a>{" "}
            (Call or Text 24/7)
          </Typography>
          <Typography sx={{ fontSize: 12, color: "#7C2D12", lineHeight: 1.4 }}>
            🏢 <strong>Employee Assistance Program (EAP):</strong> Contact your HR or call{" "}
            <a href="tel:18003274357" style={{ color: "#7C2D12", textDecoration: "underline" }}>
              1-800-EAP-HELP
            </a>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CrisisReferralCard;
